import { applyResolvedUrlsToDoc } from '@odo/shared-ui';
import type { VirtualAppointmentDto } from '../../services/virtualAppointments';
import type { VirtualAppointmentDraft } from './virtualAppointmentDraft';

export function applyImageUrlsToDrafts(
    drafts: VirtualAppointmentDraft[],
    urls: Record<string, string>
): VirtualAppointmentDraft[] {
    return drafts.map((d) => ({
        ...d,
        descriptionDoc: applyResolvedUrlsToDoc(d.descriptionDoc, urls)
    }));
}

export function applyImageUrlsToDtos(
    vas: VirtualAppointmentDto[],
    urls: Record<string, string>
): VirtualAppointmentDto[] {
    return vas.map((va) =>
        va.descriptionDoc
            ? { ...va, descriptionDoc: applyResolvedUrlsToDoc(va.descriptionDoc, urls) }
            : va
    );
}
